import { permissions } from './permissions';

export const sidebar = {
    system: [
        {
            title: 'Home',
            icon: 'mdi-home',
            to: '/',
            hideInProduction: false
        },
        {
            title: 'Alerts',
            icon: 'mdi-message-alert',
            role: permissions.alert.view,
            to: 'alerts',
            hideInProduction: false
        },
        {
            title: 'Prepack',
            icon: 'mdi-package-variant',
            role: permissions.prepack.view,
            to: 'prepack',
            hideInProduction: false
        },
        {
            title: 'Packages',
            icon: 'mdi-package',
            role: permissions.package.view,
            subMenu: [
                {
                    title: 'All',
                    to: 'packages',
                    role: permissions.package.view
                },
                {
                    title: 'Unprocessed',
                    to: 'packages-unprocessed',
                    role: permissions.package.view
                }
            ]
        },
        {
            title: 'Warehouses',
            icon: 'mdi-warehouse',
            role: permissions.warehouses.view,
            subMenu: [
                {
                    title: 'All',
                    to: 'warehouses',
                    role: permissions.warehouses.view
                },
                {
                    title: 'Unprocessed',
                    to: 'warehouses-unprocessed',
                    role: permissions.warehouses.view
                }
            ]
        },
        {
            title: 'Shipments',
            icon: 'mdi mdi-clipboard-list',
            role: permissions.shipments.view,
            subMenu: [
                {
                    title: 'All',
                    to: 'shipments',
                    role: permissions.shipments.view
                },
                {
                    title: 'Unprocessed',
                    to: 'shipments-unprocessed',
                    role: permissions.shipments.view
                }
            ],
            hideInProduction: false
        },
        {
            title: 'Repacking Requests',
            icon: 'mdi-file-table-box-multiple',
            role: permissions.repacking.view,
            to: 'repacking'
        },
        {
            title: 'Shipping Requests',
            icon: 'mdi-truck-delivery',
            role: permissions.repacking.view,
            to: 'shipping-requests'
        },
        {
            title: 'Load Units',
            icon: 'mdi mdi-file-send',
            role: permissions.loadunits.view,
            to: 'loadunits',
            hideInProduction: false
        },
        {
            title: 'Consolidated',
            icon: 'mdi mdi-text-box-check',
            role: permissions.consolidated.view,
            to: 'consolidated',
            hideInProduction: false
        },
        {
            title: 'Customers',
            icon: 'mdi mdi-account-group',
            role: permissions.customer.view,
            to: 'customers',
            hideInProduction: false
        },
        {
            title: 'PoBOX',
            icon: 'mdi-mailbox',
            to: 'pobox',
            role: permissions.pobox.view,
            hideInProduction: false
        },
        {
            title: 'Invoices',
            icon: 'mdi-invoice-list',
            to: 'invoices',
            role: permissions.invoices.view,
            hideInProduction: false
        },
        {
            title: 'Payments',
            icon: 'mdi-cash-multiple',
            to: 'payments',
            role: permissions.payments.view,
            hideInProduction: false
        },
        {
            title: 'Pickups',
            icon: 'mdi-truck-check',
            subMenu: [
                {
                    title: 'List',
                    to: 'pickups',
                    role: permissions.pickups.view
                },
                {
                    title: 'Routes',
                    to: 'routes-pickups',
                    role: permissions.pickups_orders.view
                }
            ],
            hideInProduction: false
        },
        {
            title: 'Delivery List',
            icon: 'mdi-clipboard-check',
            role: permissions.deliveryList.view,
            to: 'delivery-list',
            hideInProduction: false
        }
    ]
};
